// make sure all the images of scholars should be square

import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Background from "../../image/background10.jpg";
import { useState,useEffect } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export default function JoyOverview() {
    const [Students, setStudentlist] = useState(null);
    const [open, setOpen] = useState(false);
    const [activeStudent, setActiveStudent] = useState();
    const [activeStudentDesc, setActiveStudentDesc] = useState();

    const handleClickOpen = (stud, desc) => {
        setActiveStudent(stud);
        setActiveStudentDesc(desc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    
    const getData=()=>{
        fetch(process.env.PUBLIC_URL+'/data/studentlist.json'
        ,{
            headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            }
        }
        )
        .then(function(response){
        console.log(response)
        return response.json();
        })
        .then(function(myJson) {
        console.log(myJson);
        setStudentlist(myJson);
        });
    }

    useEffect(()=>{
    getData();
    },[])


    const alumni = Students!==null? Students.filter(p =>
        p.alumni === true
    ):" ";

    const students = Students!==null? Students.filter(p => 
        p.alumni !== true
    ):" ";

    const printstudent = (type) => type!==" "? type.map((p, index)=>
        <Col key={index}>
        <Card style={{marginBottom:"30px"}} className="publications-list">
            <Card.Img variant="top" src={p.image?process.env.PUBLIC_URL+"/data/images/students/"+p.image:process.env.PUBLIC_URL+"/data/images/student_placeholder.jpg"} />
            <Card.Body><Card.Title className="student-name"> {p.name}
            </Card.Title>
                
            </Card.Body>
            <Card.Footer style={{display:"flex", flexDirection:"row"}}>
                <div style={{flex:1}}>
                    {p.linkedin? <a href={p.linkedin} target="_blank"> <i class="bi bi-linkedin"></i> </a> :" "} 
                    {p.weblink? <a href={p.weblink} target="_blank"> <i class="bi bi-globe"></i> </a> :" "} 
                    {p.report? <a href={process.env.PUBLIC_URL+"/data/files/reports/"+p.report} target="_blank"> <i class="bi bi-file-earmark-medical"></i> </a> :" "}
                </div>
                <div>
                    <span style={{cursor:"pointer", color:"#0d6efd"}} onClick={()=>handleClickOpen(p.name, p.shortDescription)}>Know More</span>
                </div>
            </Card.Footer>
        </Card>
        </Col>  
    ): " ";

    return(<>
    
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {activeStudent}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{fontSize:"14px"}}>
            {activeStudentDesc}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    
    <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
        <Container>
            <Row className="justify-content-center section">
                <Col md="8" sm="12" className="image-over-section">
                    <h2 style={{textAlign:"center"}}>FRUGAL INNOVATION "JOYLAB"</h2>
                    <p style={{textAlign:"center"}}>Frugal Innovation Lab which we love to simply call JoyLab, is a space of collaboration, co-creation and celebration. Passionate individuals from diverse backgrounds come together here to immersively explore the possibility of creating deep value and beauty through research which is primarily carried out in the field. The broad areas of exploration are Design for Sustainability, Traditional Knowledge Systems and Joyous Self-Discovery. More specifically, research in JoyLab has centred around Ecological Sanitation, Green Housing & Frugal Innovations inspired by Traditional Knowledge. We love to partner with grassroot organisations and individuals who are changemakers at heart and are driven by the values of empathy & diversity, inclusion and creativity.</p>
                    <Button href="https://forms.gle/RKXzzWw1RTLNNZo86" target="_blank">Connect To JoyLab <i className="bi bi-box-arrow-up-right"></i></Button>
                </Col>
            </Row>
        </Container>
        </Container>
        
        <Container>
                <h2 style={{textAlign:"center", marginTop:"30px"}}>Doctoral Students</h2>
                <Row md="4" sm="2" xs="1">
                {printstudent(students)}
            </Row>
        </Container>

        <Container>
                <h2 style={{textAlign:"center", marginTop:"30px"}}>Doctoral Alumi</h2>
            <Row md="4" sm="2" xs="1">
                {printstudent(alumni)}
            </Row>
        </Container>
        </>
    )
}